export default {
  props: {
    selectedEntity: {
      type: Object,
      required: false,
      default: null
    }
  }
}
